module.exports = __webpack_public_path__ + "img/broken-video.ce8e8230.svg";